export const page_options = [
  { value: 'page_url', label: 'Page URL' },
  { value: 'page_title', label: 'Page Title' }
]

export const visitor_options = [
  { value: 'email', label: 'Email' },
  { value: 'visitor_id', label: 'Visitor ID' }
]

export const behavior_options = [{ value: 'time_on_page', label: 'Time on page' }]

export const page_condition_options = [
  { value: 'is_equal_to', label: 'is equal to' },
  { value: 'contains', label: 'contains' },
  { value: 'does_not_contain', label: 'does not contain' }
]

export const visitor_condition_options = [
  { value: 'is_set', label: 'is set' },
  { value: 'is_not_set', label: 'is not set' }
]

export const behavior_condition_options = [{ value: 'greater_than', label: 'greater than' }]

export const action_options = [
  { value: 'goToStep', label: 'Go to step' },
  { value: 'link', label: 'Open link in new tab' },
  { value: 'submit', label: 'Submit' }
]
